import React, {useEffect, useState} from 'react'
import {Checkbox, message, Modal} from 'antd'
import {batchSetMonitorBigScreenPlay} from '@apis'

export default function AddProgram({
  visible = false,
  switchVisible = () => {},
  monitorList = [],
  queryMonitorList = () => {},
}) {
  const [monitorListData, setMonitorListData] = useState([])

  function updateCheckedStatus(index, checked) {
    const newMonitorListData = monitorListData.slice(0)
    newMonitorListData[index].dataBigscreenDisplay = checked ? 1 : 0
    setMonitorListData(newMonitorListData)
  }

  // 修改节目勾选
  async function updateMonitor() {
    const addBigScreenPlaySetIdList = monitorListData.filter(item => item.dataBigscreenDisplay === 1).map(item => item.id)
    const delScreenPlaySetIdList = monitorListData.filter(item => item.dataBigscreenDisplay !== 1).map(item => item.id)
    const params = {
      brokerId: monitorListData[0].brokerId,
      addBigScreenPlaySetIdList,
      delScreenPlaySetIdList
    }
    const res = await batchSetMonitorBigScreenPlay(params)
    if (res) {
      message.success('操作成功')
      switchVisible(false)
      queryMonitorList()
    }
  }

  useEffect(() => {
    if (visible) {
      setMonitorListData(JSON.parse(JSON.stringify(monitorList)))
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title={'编辑节目列表'}
      style={{top: 200}}
      okText='确认'
      cancelText='取消'
      onCancel={() => {
        switchVisible(false)
      }}
      onOk={() => {
        updateMonitor()
      }}
      width={560}
    >
      <div className="add-monitor">
        <div className="monitor-form-box">
          <div className="monitor-list">
            {
              monitorListData.map((item, index) => (
                <div
                  className="monitor-item"
                  onClick={() => {
                    updateCheckedStatus(index, item.dataBigscreenDisplay !== 1)
                  }}
                >
                  <Checkbox
                    checked={item.dataBigscreenDisplay === 1}
                  />
                  <span className="monitor-sp">{index + 1}</span>
                  <span>{item.name}</span>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </Modal>
  )
}